import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Autentificare reușită");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full bg-white border border-black rounded-none px-4 py-3 focus:outline-none";

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-6 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-black p-8 md:p-12">
        <div className="font-mono-label text-black/60">Admin</div>
        <h1 className="mt-3 font-display font-medium uppercase text-4xl tracking-tighter">Autentificare</h1>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="font-mono-label text-black/60 block mb-2">Email</label>
            <input required type="email" data-testid="admin-email-input" className={input} value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="font-mono-label text-black/60 block mb-2">Parolă</label>
            <input required type="password" data-testid="admin-password-input" className={input} value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button disabled={loading} type="submit" data-testid="admin-login-submit"
            className="w-full font-mono-label bg-black text-white px-6 py-4 hover:bg-white hover:text-black border border-black inline-flex items-center justify-center gap-2 disabled:opacity-50">
            {loading ? "Se autentifică..." : "Autentificare"} <ArrowRight size={14} />
          </button>
        </form>
      </div>
    </div>
  );
}
